import { avalanche } from '@0xtorch/core'
import { avalanche as viemAvalanche } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createAvalancheCChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createAvalancheCChainCustom({
    client: createClient({
      chain: viemAvalanche,
      httpRpcs: avalancheCHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'Snowscan',
      baseUrl: 'https://snowscan.xyz',
      chainId: 43_114,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateAvalancheCChainParameters = {
  client: Client
  explorer: Explorer
}

export const createAvalancheCChainCustom = ({
  client,
  explorer,
}: CreateAvalancheCChainParameters): Chain => ({
  id: 43_114,
  network: 'avalanche-c',
  name: 'Avalanche C-Chain',
  nativeToken: {
    name: 'Avalanche',
    symbol: 'AVAX',
    decimals: 18,
    currency: avalanche,
  },
  wrappedTokenAddresses: new Set([
    '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'avalanche',
  defillamaId: 'avax',
})

export const avalancheCHttpRpcs: HttpRpc[] = [
  {
    url: 'https://api.avax.network/ext/bc/C/rpc',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2048n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://avax.rpcgator.com/',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // {
  //   url: 'https://avalanche.public-rpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 2048n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://avalancheapi.terminet.io/ext/bc/C/rpc',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://avalanche-c-chain-rpc.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://avalanche-c-chain.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 20_000n,
  // },
  {
    url: 'https://1rpc.io/avax/c',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://avalanche.blockpi.network/v1/rpc/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 1024n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://avax-pokt.nodies.app/ext/bc/C/rpc',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://avalanche.api.onfinality.io/public/ext/bc/C/rpc',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://endpoints.omniatech.io/v1/avax/mainnet/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 3000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://avax.meowrpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://api.zan.top/node/v1/avax/mainnet/public/ext/bc/C/rpc',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://avalanche.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2048n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://public.stackup.sh/api/v1/node/avalanche-mainnet',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://avax-x-mainnet.gateway.tatum.io',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
]

export const avalancheCWebsocketRpcUrls: readonly string[] = [
  'wss://avalanche-c-chain-rpc.publicnode.com',
]
